import { getChartLabelIdOrName } from '@modules/charts/utils';
import { GetChartLabelOptions } from '@modules/common/types';
import { CompareReportDataPoint } from '@modules/quantify/store/types';
import { Box, Stack, Typography } from '@mui/material';

interface CompareChartTootlipLabelProps {
  payload: CompareReportDataPoint | null;
  getLabelOptions?: GetChartLabelOptions;
}

export const CompareChartTootlipLabel = ({
  payload,
  getLabelOptions,
}: CompareChartTootlipLabelProps) => {
  const tooltipLabelOptions =
    payload &&
    getLabelOptions?.({
      id: payload.id,
      size: 14,
      showIndentForEmptySecondaryIcon: false,
      shouldHideTooltip: true,
    });

  const hasCategory =
    tooltipLabelOptions?.startIcon && tooltipLabelOptions?.label;

  return (
    <Stack px={1.5} spacing={1}>
      <Stack direction="row" alignItems="flex-start" columnGap={0.5}>
        {tooltipLabelOptions?.startIcon && (
          <Box pt={0.3}>{tooltipLabelOptions.startIcon}</Box>
        )}
        <Typography
          variant="body2"
          sx={{
            wordWrap: 'break-word',
          }}
          width={hasCategory ? 'calc(100% - 20px)' : '100%'}
          color={
            tooltipLabelOptions?.isDisabled ? 'text.disabled' : 'text.primary'
          }
        >
          {tooltipLabelOptions?.label && `${tooltipLabelOptions.label}: `}
          {getChartLabelIdOrName(payload?.label)}
        </Typography>
        {tooltipLabelOptions?.endIcon && (
          <Stack pt={0.3}>{tooltipLabelOptions.endIcon}</Stack>
        )}
      </Stack>
      {tooltipLabelOptions?.messageNode && tooltipLabelOptions.messageNode}
    </Stack>
  );
};
